import './cncrouter.css'
import '../projectscontent.css'
import { TypingText } from "../../../../components/glowingtextcomponet/typingtext.js";

export const CncRouter = () => (
    <div>
        <TypingText content='Coming Soon.' />
    </div>
);
